/**
 * Typed PostHog events for the group-ordering + split-pay surfaces.
 *
 * Every event is tagged with `source: 'online_ordering_v2'` (set in
 * `analytics.initAnalytics()`) and grouped under `company: tenantId` (set
 * in `branch.tsx` once the public config resolves), so the unified PostHog
 * project (78456) can split per-app and per-tenant without extra plumbing.
 *
 * Events stay flat key/value to keep PostHog property auto-typing useful.
 * No PII — display names only flow through if the user opted to set one,
 * and we never send raw payment intent payloads.
 */
import { track } from "./analytics";

// --- Group cart ---------------------------------------------------------------

export function trackGroupCartCreated(props: {
  groupCartId: string;
  branchId: string;
  tableId: string;
  seedLineCount: number;
}): void {
  track("group_cart_created", props);
}

export function trackGroupCartJoined(props: {
  groupCartId: string;
  via: "code" | "id" | "probe_redirect";
  participantCount: number;
}): void {
  track("group_cart_joined", props);
}

export function trackGroupCartFired(props: {
  groupCartId: string;
  orderId: string;
  firedLineCount: number;
  participantCount: number;
}): void {
  track("group_cart_fired", props);
}

export function trackGroupCartAbandoned(props: {
  groupCartId: string;
  reason: "user_left" | "sse_abandoned";
}): void {
  track("group_cart_abandoned", props);
}

// --- Split pay ----------------------------------------------------------------

export function trackSplitCreated(props: {
  orderId: string;
  splitId: string;
  method: "card" | "cash";
  claimedLineCount: number;
  myShareAmount: number;
  inGroup: boolean;
}): void {
  track("split_created", props);
}

export function trackSplitClaimedLine(props: {
  orderId: string;
  lineId: string;
  totalSharers: number;
}): void {
  track("split_claimed_line", props);
}

export function trackSplitUnclaimedLine(props: {
  orderId: string;
  lineId: string;
  totalSharers: number;
}): void {
  track("split_unclaimed_line", props);
}

export function trackSplitSharedLine(props: {
  orderId: string;
  lineId: string;
  sharers: number;
}): void {
  track("split_shared_line", props);
}

export function trackSplitPaid(props: {
  orderId: string;
  splitId: string;
  method: "card" | "cash";
  amount: number;
}): void {
  track("split_paid", props);
}

export function trackCoverageBlocked(props: {
  orderId: string;
  uncoveredLineCount: number;
  method: "card" | "cash";
}): void {
  track("coverage_blocked", props);
}
